export default "__VITE_ASSET__0b361311__"